import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class UpdateService {
  constructor(
    private updates: SwUpdate,
    private messageService: MessageService,
  ) {}

  checkForUpdates() {
    if (this.updates.isEnabled) {
      this.updates.versionUpdates.subscribe((event) => {
        if (event.type === 'VERSION_READY') {
          this.messageService.add({
            severity: 'success',
            summary:
              'نسخه جدیدی از برنامه موجود است. لطفاً صفحه را بروزرسانی کنید.',
          });
          if (
            confirm(
              'نسخه جدیدی از برنامه منتشر شده. آیا می‌خواهید صفحه را بروزرسانی کنید؟',
            )
          ) {
            this.updates
              .activateUpdate()
              .then(() => document.location.reload());
          }
        }
      });
    }
  }
}
